import type { DepositStatusUnionType } from '@api';
import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { getDepositStatusColor } from './helpers';

type DepositStatusBadgePropsType = {
  status: DepositStatusUnionType;
};

export const DepositStatusBadge: React.FC<DepositStatusBadgePropsType> = ({
  status,
}) => {
  const { t } = useTranslation('financeDeposits');
  const { backgroundColor, textColor } = getDepositStatusColor(status);

  return (
    <Badge color={backgroundColor} style={{ color: textColor }}>
      {t(`DEPOSITS_TABLE.ENUMS.STATUS.${status}`)}
    </Badge>
  );
};
